import { ValidationErrors, AbstractControl, Validators, ValidatorFn, FormGroup } from "@angular/forms";

export class ValidationService {

  static dateValidator(control: AbstractControl): ValidationErrors | null {
    const dateReg = '[0-9]{4}-[0-9]{2}-[0-9]{2}';   ///^\d{2}([./-])\d{2}\1\d{4}$/; //2020-06-11 
    if (control && control.value) {
      return { "date": true };
    }
    return null; 
  }

  static date(control: AbstractControl): ValidationErrors | null { 
    let value = control.value;
    if (value && typeof value === "string") {
      let match = value.match(/^([0-9]{4})\/([0-9]{1,2})\/([0-9]{1,2})$/); //value.match(/^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/);
      if (!match) {
        return { 'date': true };
      } else if (match && match[0] !== value) {
        return { 'date': true };
      }
    }
    return null;

    //const dateReg = new RegExp(/^02\/(?:[01]\d|2\d)\/(?:19|20)(?:0[048]|[13579][26]|[2468][048])|(?:0[13578]|10|12)\/(?:[0-2]\d|3[01])\/(?:19|20)\d{2}|(?:0[469]|11)\/(?:[0-2]\d|30)\/(?:19|20)\d{2}|02\/(?:[0-1]\d|2[0-8])\/(?:19|20)\d{2}$/); 

    //if (dateReg.test(control.value) || control.value === null || control.value === "") {
    //  return null
    //}
     
    //return { "date": true };
  }

  static zipCodeValidator(control: AbstractControl): ValidationErrors | null { 
    const zipReg = '[0-9]{5}';
    if (control.value) {
      const regEx = new RegExp(/[0-9]{5}/);
      if (!regEx.test(control.value)) {
        return { 'zipCode': true };
      }
    }
    return null;    
    //if (control.value.match(zipReg) || control.value === "" || control.value === null) {
    //  return null;
    //} else {
    //  return { "zipCode": true };
    //}
  }

  static alphaNumericValidator(control: AbstractControl): ValidationErrors | null{ 
      if (control.value) { 
        //const regEx = new RegExp(/^[a-zA-Z0-9]*$/); // no spaces
        const regEx = new RegExp(/^[a-zA-Z0-9\d\-_\s]+$/i);
        if (!regEx.test(control.value)) {
          return { 'alphaNumeric': true };
        }
      }
      return null;    
  }

  static alphaNumericSpecialCharactersValidator(control: AbstractControl): ValidationErrors | null { 
    if (control.value) {
      const regEx = new RegExp(/^[a-zA-Z.-]+(?:[\s-][/a-zA-Z.]+)*$/);
      if (!regEx.test(control.value)) {
        return { 'alphaNumericSpecialCharacters': true };
      }
    }
    return null;
  }
   
  static numericValidator(control: AbstractControl): ValidationErrors | null {
    if (control.value) {
      const reg = new RegExp('^-?[0-9]\\d*(\\.\\d{1,2})?$');

      if (!reg.test(control.value)){
          return { "numeric": true };
      }
    }
    return null;
  }

  static phoneValidator(control: AbstractControl): ValidationErrors | null { 
    if (control.value) {
      //const phoneRegex = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
      const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

      if (!phoneRegex.test(control.value)) {
        return { 'phone': true };
      }
    }
    return null;
  }

  static urlValidator(control: AbstractControl): ValidationErrors | null {
    if (control.value) { 
      const URL_REGEXP = /^(http?|https):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;

      //control.markAsTouched();

      //if (!URL_REGEXP.test(control.value)) { 
      //  return {
      //    "url": true
      //  };
      //} 
    }

    return null;
  }

  //static storeLocationCompareValidator(): ValidatorFn | null {

  //  return (formGroup: FormGroup) => {
  //    const source = formGroup.get('sourceStoreLocationId');
  //    const destination = formGroup.get('destinationStoreLocationId');
      

  //    if (source == destination) {
  //      return { 'storeLocation': true };
  //    }

  //    return null;


  //    //if (control.value) {
  //    //  //safety check
  //    //  if (control.get('sourceStoreLocationId').value == control.get('destinationStoreLocationId').value) {
  //    //    return { 'storeLocation': true };
  //    //  }
  //    //  return null;
  //    //}
  //  }
  //}
}
